import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../../lib/moment.js'
import SearchIcon from "../../../static/images/search_icon.svg"
import { DateHeader } from '../helpers/header'
import metrolendarHelper from '../../timesheet/helpers/date'

export const TimesheetByProjects = class extends React.Component {
  state={ tempSearch: this.props.searchTimesheet }

  render() {
    const dates = metrolendarHelper.getTableDates(moment(get(this.props, 'selectedDateProjects')), 'month')

    return (
      <Wrapper>
        <SearchField
          placeholder='Search by employee'
          value={ this.state.tempSearch }
          onChange={ (e) => {
            if (e.target.value === '') this.props.handleChangeSearch(e.target.value)
            this.setState({ tempSearch: e.target.value })
          }
          }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) this.props.handleChangeSearch(this.state.tempSearch)
          } }
        />
        <DateHeader dates={ dates } activeTab={ this.props.activeTab } />
      </Wrapper>
    )
  }
}

TimesheetByProjects.propTypes = {
  activeTab: PropTypes.number,
  handleChangeSearch: PropTypes.func,
  searchTimesheet: PropTypes.string,
}
TimesheetByProjects.defaultProps = {
  activeTab: 1,
  handleChangeSearch: () => {},
  searchTimesheet: '',
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  font-family: 'Gotham-Bold' !important;
  font-size: 16px ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const SearchField = styled.input`
  height: 30px;
  width: 200px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 10px;
  background-size: 15px 15px;
  font-family: 'Gotham' !important;
  font-size: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1% !important;
  margin-right: 1% !important;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`




// WEBPACK FOOTER //
// ./src/components/timesheet/search-bar/timesheet-by-projects.js